import axios, { AxiosRequestTransformer } from 'axios';

/**
 * Criacao do objeto api
 */

const isPlainObject = (v: unknown): v is Record<string, any> =>
    Object.prototype.toString.call(v) === '[object Object]';

// Função para transformar datas em strings
const transformDates = (data: any): any => {
    if (data instanceof Date) {
        const year = data.getFullYear();
        const month = String(data.getMonth() + 1).padStart(2, '0');
        const day = String(data.getDate()).padStart(2, '0');
        const hours = String(data.getHours()).padStart(2, '0');
        const minutes = String(data.getMinutes()).padStart(2, '0');
        const seconds = String(data.getSeconds()).padStart(2, '0');
        return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`; // YYYY-MM-DDTHH:mm:ss
    }
    if (Array.isArray(data)) {
        return data.map(transformDates);
    }
    if (isPlainObject(data)) {
        return Object.fromEntries(
            Object.entries(data).map(([key, val]) => [key, transformDates(val)])
        );
    }
    return data;
};

//se tiver passando datas nos parametros do get, use essa função, se não vai ficar 3 horas à frente
export const transformParams = (params: Record<string, any>): Record<string, any> => {
    return Object.fromEntries(
        Object.entries(params).map(([key, value]) => {
            if (value instanceof Date) {
                return [key, transformDates(value)];
            }
            return [key, value];
        })
    );
};

axios.defaults.transformRequest = [(data) => {
    return transformDates(data);
}, ...axios.defaults.transformRequest as AxiosRequestTransformer[]];


const api = axios.create({
    baseURL: process.env.REACT_APP_API_ENTRYPOINT,
    headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
    },
});

const apiPublic = axios.create({
    baseURL: process.env.REACT_APP_API_ENTRYPOINT,
    headers: {
        'Content-Type': 'application/json',
    },
});

const apiFile = axios.create({
    baseURL: process.env.REACT_APP_API_ENTRYPOINT,
    headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
    },
});

api.interceptors.response.use(
    response => response,
    error => {
        if (error.response && error.response.status === 401) {

            // TODO logoff

        }

        return Promise.reject(error);
    });

export { api, apiFile, apiPublic };
